import { Component, OnInit } from '@angular/core';
import { Auth, ViewState} from 'src/common'
@Component({
  selector: 'app-internaluser-edit',
  templateUrl: './internaluser-edit.component.html'

})
export class InternalUserEditComponent  implements OnInit{

  viewState = ViewState;
  
  constructor() { }

  ngOnInit (): void {
    //Auth.checkAuthorization('');
    
    
  }


}